
// contexts/ShowDivContext.js

import { createContext } from 'react';

export const UserLogged = createContext({
  userLogged: true,
  setUserLogged: (value: boolean) => {},
});
